import { ExtendedCSS } from '@primeuix/themes/types';
import borderCss from './border-style';
import fullHeight from './full-height';

const css: ExtendedCSS = ({ dt }) => `
${borderCss(dt)}
${fullHeight}
`;

export default {
  css,
};
